/**
 * Server search uses custom highlight sentinels (see Go `HighlightStartTag` / `HighlightEndTag`).
 * Same convention as `mobile/.../text_markup.utility.dart`.
 */
const HIGHLIGHT_PAIR = /([\s\S]*?)<&>([\s\S]*?)<\/&>([\s\S]*)/

export type SearchHighlightSegment = {
  highlighted: boolean
  text: string
}

/** Split API text into plain / highlighted runs for rendering. */
export function parseSearchHighlightSegments(text: string): SearchHighlightSegment[] {
  if (!text) return []

  const segments: SearchHighlightSegment[] = []
  let remaining = text

  for (;;) {
    const match = remaining.match(HIGHLIGHT_PAIR)
    if (!match) {
      if (remaining.length > 0) {
        segments.push({ highlighted: false, text: remaining })
      }
      break
    }
    const [, before, highlighted, after] = match
    if (before) segments.push({ highlighted: false, text: before })
    if (highlighted) segments.push({ highlighted: true, text: highlighted })
    remaining = after ?? ''
  }

  return segments
}

/** Plain text only (no sentinel tags), for alt text, recents, initials, etc. */
export function stripSearchHighlightMarkup(text: string): string {
  return parseSearchHighlightSegments(text)
    .map((s) => s.text)
    .join('')
}

/** Whether the text carries at least one complete `<&>…</&>` highlight run. */
export function containsSearchHighlight(text: string | undefined | null): boolean {
  return !!text && HIGHLIGHT_PAIR.test(text)
}
